import React, { useEffect, useState } from "react";
import RadioButton from "./RadioButton";
import "./BottomSection.scss";
import FormSection from "./FormSection";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { getToken } from "../../auth/authConfig";
import axios from "axios";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Alert, Box, Snackbar } from "@mui/material";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { auditSwitchType, protocolType, scoringSubmit, switchProtocolType } from "../../../store/audit details/atom";
import { useNavigate } from "react-router-dom";
import {login} from "../../auth/msalAuth";
const conformanceRadioData = [
  { id: 1, label: "Compliant", value: "Compliant", name: "conformance" },
  {
    id: 2,
    label: "Needs Improvement",
    value: "Needs Improvement",
    name: "conformance",
  },
  { id: 3, label: "At Risk", value: "At Risk", name: "conformance" },
  {
    id: 4,
    label: "Gap Assessment",
    value: "Gap Assessment",
    name: "conformance",
  },
];

const topSectionRadioData = [
  {
    id: 1,
    label: "Yes",
    value: "Yes",
    name: "Review",
    isChecked: true,
  },
  {
    id: 2,
    label: "No",
    value: "No",
    name: "Review",
    isChecked: false,
  },
];

const intialSubmitObj = {
  formId: "",

  areaStrength: "",

  areaOpportunity: "",

  zeroFindingJustification: "",

  auditDurationHour: "",

  auditDurationMinutes: "",

  isTechReviewDone: true,
};

const BottomSection = ({ scoringLoading, scoringData, auditNumber, setScoringData }) => {
  const selectedConformance = scoringData?.conformance_level || "";
  const [selectedValue, setSelectedValue] = useState("No");
  console.log("selected value", selectedValue)
  const [hourValue, setHourValue] = useState(scoringData?.auditDurationHour
  );
  const [minuteValue, setMinuteValue] = useState(
    scoringData?.auditDurationMinutes
  );
  const [openPopup, setOpenPopup] = useState(false);
  console.log("scoring data", scoringData)
  const refineScoringData = {
    ...scoringData,
    areaStrength :scoringData?.areaStrength && scoringData?.areaStrength.value,
    areaOpportunity: scoringData?.areaOpportunity && scoringData?.areaOpportunity.value,
    zeroFindingJustification: scoringData?.zeroFindingJustification && scoringData?.zeroFindingJustification.value

  }

  console.log("refine object", refineScoringData)
  const [postScoringDetails, setPostScoringDetails] = useState({
    // ...intialSubmitObj,
    ...refineScoringData,
    formId: auditNumber,
  });
  const [submitDataLoading, setSubmitDataLoading] = useState(false);
  const [submitDataError, setSubmitDataError] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const setSubmitScoringValue = useSetRecoilState(scoringSubmit);
  const navigate = useNavigate();
  const setSwitchValue = useSetRecoilState(auditSwitchType);
  const getStoredProtocol = useRecoilValue(switchProtocolType);
  const setProtocolType = useSetRecoilState(protocolType);
  const [auditConclusionTrue, setAuditConclusionTrue] = useState(false);
  const [error, setError] = useState(false);



  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleGoBack = () => {
    setSwitchValue("change");
    if (getStoredProtocol) {
      setProtocolType(getStoredProtocol);
    }
  };
  const sectionsData = [
    {
      id: "strength",
      label:
        "Areas of Strength - Identify minimum 2 areas of strength for the unit and why",
      defaultText: scoringData?.areaStrength?.value ?? "",
      disable : scoringData?.areaStrength?.isVerified === "Verified" ? true : false
    },
    {
      id: "opportunity",
      label:
        "Areas of Opportunity - Identify minimum 2 areas of opportunity for the unit and why",
      defaultText: scoringData?.areaOpportunity?.value ?? "",
      disable : scoringData?.areaOpportunity?.isVerified === "Verified" ? true : false
    },
    {
      id: "zero_findings",
      label:
        "If this audit had zero findings - please justify the unit’s success to share for learnings.",
      defaultText: scoringData?.zeroFindingJustification?.value ?? "",
      disable : scoringData?.zeroFindingJustification?.isVerified === "Verified" ? true : false
    },
  ];

  console.log("postScoring", postScoringDetails)
  const submitData = async (activity) => {
    const submitDataURL = `${process.env.REACT_APP_SERVER_URL}/api/scoring/sentback`;
    const token = await getToken();
    setSubmitDataLoading(true);
    try {
      if (activity === "saved") {
        setSnackbarMessage("Form Saved Successfully!");
        setSaveLoading(true);
      }
      if (activity === "completed") {
        setSubmitLoading(true);
      }
        
      const payload = { formId : postScoringDetails?.formId,
         areaStrength : postScoringDetails?.areaStrength,
          areaOpportunity: postScoringDetails?.areaOpportunity,
            zeroFindingJustification: postScoringDetails?.zeroFindingJustification,
             auditDurationHour : hourValue,
              auditDurationMinutes: minuteValue,
               isTechReviewDone: false,
                activity: activity };
      console.log("payload", payload)
      const response = await axios.post(
        submitDataURL,
        payload,
        {
          headers: {
            "oidc-token": token,
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.status === 201) {
        setSubmitDataLoading(false);
        if (activity === "saved") {
          setSaveLoading(false);
          setOpen(true);
        }
        if (activity === "completed") {
          setSubmitLoading(false);
          setSubmitScoringValue(true);

          setTimeout(() => {
            setSubmitScoringValue(false);
            navigate("/");
          }, 3000);
        }
      } else {
        setSubmitDataError("Oops! Something went wrong. . .");
      }
    } catch (e) {
      const status = e?.response?.status;
      if (status === 401) {
        login();
      }
      if (status === 500) {
        setError(true);
        setTimeout(() => {
          setError(false);
        }, 3000);
      }
      if (activity === "saved") {
        setSaveLoading(false);
      }
      if (activity === "completed") {
        setSubmitLoading(false);
      }
      setSubmitDataLoading(false);
      setSubmitDataError("Oops! Something went wrong. . .");
    } finally {
      setSubmitDataError(false);
      if (activity === "saved") {
        setSaveLoading(false);
      }
      if (activity === "completed") {
        setSubmitLoading(false);
      }
      
    }
  };

  useEffect(() => {
    setPostScoringDetails((prev) => {
      if (
        prev.auditDurationHour !== hourValue ||
        prev.auditDurationMinutes !== minuteValue 
        // prev.isTechReviewDone !== (selectedValue === "Yes")
      ) {
        return {
          ...prev,
          auditDurationHour: hourValue,
          auditDurationMinutes: minuteValue,
          // isTechReviewDone: selectedValue === "Yes",
        };
      }
      return prev;
    });
  }, [hourValue, minuteValue, selectedValue]);

  console.log("getting this scorre data", scoringData)

  return (
    <>
      <div className="scoring-bottom-section">
        <h3 className="audit-conclusion">Audit Conclusion</h3>
        <div className="conformance-radio-cont">
          <p>Mars QMS Audit Conformance Level:</p>
          {conformanceRadioData.map((radio) => (
            <RadioButton
              key={radio.id}
              id={radio.id + "conformance_level"}
              value={radio.value}
              label={radio.label}
              name={radio.name}
              isChecked={radio.value.includes(selectedConformance)}
              disabled={!radio.value.includes(selectedConformance)}
            />
          ))}
        </div>

        <div className="form-section-cont">
          <FormSection
            setPostScoringDetails={setPostScoringDetails}
            formData={sectionsData}
            setAuditConclusionTrue = {setAuditConclusionTrue}
            auditConclusionTrue = {auditConclusionTrue}
            setScoringData = {setScoringData}
          />
        </div>

        <div className="duration-section">
          <p>
            Audit duration (Hours)<span className="required-field"> *</span>
          </p>

          <div className="time-section">
            <div className="hours">
              <input
                type="number"
                name="hours"
                id="hours"
                value={hourValue}
                onChange={(e) => setHourValue(e.target.value)}
                disabled
              />
              <label htmlFor="hours">Hours</label>
            </div>
            <div className="minutes">
              <input
                type="number"
                name="minutes"
                id="minutes"
                value={minuteValue}
                onChange={(e) => setMinuteValue(e.target.value)}
                disabled
              />
              <label htmlFor="minutes">Minutes</label>
            </div>
          </div>

        
        </div>
        <div className="bottom-btn-container">
          <p>
            Fields marked <span className="required-field"> *</span> are
            Required.
          </p>
          <div className="validate-btn-container">
          <button onClick={handleGoBack} className="primary-btn-validate">
              Go Back
            </button>
            {saveLoading ? (
              <button disabled className="primary-btn-validate">
                Loading...
              </button>
            ) : (
              <button
                onClick={() => submitData("saved")}
                className="primary-btn-validate"
              >
                Save
              </button>
            )}
            {submitLoading ? (
              <button disabled className="primary-btn-validate">
                Loading...
              </button>
            ) : (
              <button
                onClick={() => {
                  setOpenPopup(true);
                }}
                className="primary-btn-validate"
                disabled = {!auditConclusionTrue}

              >
                Submit
              </button>
            )}
          </div>
        </div>

        <Dialog
          open={openPopup}
          onClose={() => {
            setOpenPopup(false);
          }}
          id="mars-super-admin-popup"
        >
          <DialogContent>
            <div className="popup-text-container">
              <p>
                Please confirm your submission. Once submitted, your data cannot
                be changed or edited. Are you sure you want to proceed?
              </p>
            </div>
          </DialogContent>
          <DialogActions
            style={{
              padding: "24px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "40px",
            }}
          >
            <button
              className="logout-popup-btn primary-btn mars-admin-popup"
              d
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                submitData("completed");
                setOpenPopup(false);
              }}
            >
              Yes
            </button>
            <button
              className="logout-popup-btn secondary-btn mars-admin-popup"
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                setOpenPopup(false);
              }}
            >
              No
            </button>
          </DialogActions>
        </Dialog>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={open}
        onClose={handleClose}
        message={snackbarMessage}
        autoHideDuration={2000}
        className="success-snackbar"
      />
       {error && (
        <Box
          sx={{
            position: "fixed",
            top: 55,
            right: 16,
            zIndex: 1300, // Ensures it appears above other content
          }}
        >
          <Alert
            severity="error"
            sx={{
              fontSize: "20px",
              width: "auto",
            }}
          >
            Something went wrong! Please try again later.
          </Alert>
        </Box>
      )}
    </>
  );
};

export default BottomSection;
